import { makeStyles } from "@mui/styles";
import {
  outlinedBtn,
  containedBtn,
  button,
  textBtn,
  homeImageBackgroundColor,
  helperTxt,
  theme,
  txtTitle,
  secondaryTxt,
} from "assets/jss/material-react.js";

const appStyle = makeStyles(() => ({
  box: {
    alignSelf: "center",
    [theme.breakpoints.down("md")]: {
      alignSelf: "unset",
    },
    fontSize: "13px",
  },
  gridContainer: {
    justifyContent: "center",
    [theme.breakpoints.down("md")]: {
      display: "grid !important",
      alignContent: "space-between",
      height: "100%",
    },
  },
  datePickerCustom: {
    margin: "auto",
    "& label": {
      fontFamily: "Raleway",
      fontSize: "14px",
      fontWeight: "500",
      marginTop: "-5px",
    },
    "& fieldset": {
      border: "none",
      borderBottom: "1px solid #b1b1b1",
    },
    "& .MuiFormLabel-root.MuiInputLabel-root.Mui-focused": {
      color: "rgb(4 128 143)",
      marginTop: "15px",
    },
    "& input": {
      paddingTop: "22px",
      paddingBottom: "10px",
    },
    width: "100%",
    paddingTop: "0px!important",
    [theme.breakpoints.down("sm")]: {
      paddingTop: "15px!important",
      width: "90%!important",
      "& label": {},
      "& fieldset": {
        borderBottom: "1px solid #b1b1b1",
      },
    },
  },
  marginDatePickerCustom: {
    "& label": {
      marginTop: "15px!important",
    },
  },
  datePicker: {
    borderRadius: "0px!important",
    backgroundColor: "#f0f0f0!important",
    div: {
      borderRadius: "0px!important",
      backgroundColor: "#f0f0f0!important",
    },
    "& .MuiInputBase-root.Mui-focused": {
      "& fieldset": {
        borderBottom: "2px solid rgb(4 128 143)",
      },
    },
    "& .MuiInputBase-root.Mui-error": {
      "& fieldset": {
        borderBottom: "2px solid #b1b1b1",
      },
    },
    [theme.breakpoints.down("sm")]: {
      "& .MuiInputBase-root.Mui-focused": {
        "& fieldset": {
          borderBottom: "2px solid rgb(4 128 143)",
        },
      },
      "& .MuiInputBase-root.Mui-error": {
        "& fieldset": {
          borderBottom: "2px solid #b1b1b1",
        },
      },
    },
  },
  formControlCustomAutocomplete: {
    "& label": {
      fontFamily: "Raleway!important",
      fontSize: "14px",
      fontWeight: "500",
      marginTop: "-5px",
    },
    "& .MuiInputLabel-shrink": {
      marginTop: "15px",
    },
    "& .MuiFormLabel-root.MuiInputLabel-root.Mui-error": {
      color: "rgb(255,0,0,1)!important",
    },
    "& .MuiFormLabel-root.MuiInputLabel-root.Mui-focused": {
      color: "rgb(4 128 143)",
      marginTop: "15px",
    },
    "& .MuiFormControl-root .MuiInputBase-root": {
      paddingTop: "18px",
      paddingBottom: "0",
    },
    "& .MuiInputBase-root.MuiFilledInput-root": {
      "&:before": {
        borderBottom: "1px solid #b1b1b1!important",
      },
    },
    margin: "auto",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      margin: "auto",
      width: "90%!important",
      marginTop: "1rem!important",
    },
  },
  colorRed: {
    color: "rgb(255, 0, 0, 1)",
    "& label": {
      color: "rgb(255, 0, 0, 1)",
    },
  },
  formControlCustom: {
    "& label": {
      fontFamily: "Raleway!important",
      fontSize: "14px",
      fontWeight: "500",
      marginTop: "-2px",
    },
    "& .MuiFormLabel-root.MuiInputLabel-root.Mui-error": {
      color: "rgb(255,0,0,1)!important",
    },
    "& .MuiFormLabel-root.MuiInputLabel-root.Mui-focused": {
      color: "rgb(4 128 143)",
      marginTop: "-2px",
    },
    "& .MuiInputBase-root.MuiFilledInput-root": {
      "&:before": {
        borderBottom: "1px solid #b1b1b1!important",
      },
    },
    width: "100%!important",
    margin: "auto",

    [theme.breakpoints.down("sm")]: {
      width: "90%!important",
      marginTop: "1rem!important",
    },
  },
  gridForm: {
    display: "flex",
    paddingTop: "30px!important",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      paddingTop: "10px!important",
    },
  },
  inputAutocomplete: {
    backgroundColor: "#f0f0f0",
    "& fieldset": {
      border: "none",
      borderBottom: "1px solid #b1b1b1!important",
      borderRadius: "0px",
    },
    "& div.Mui-focused": {
      "& fieldset": {
        borderBottom: "2px solid rgb(4 128 143)!important",
        borderRadius: "0px",
      },
    },
  },
  inputCustom: {
    borderRadius: "0px!important",
    "& .MuiInputBase-root": {
      borderRadius: "0px!important",
    },
    "& label.Mui-focused": {
      color: "rgb(4 128 143)",
    },
    "& .MuiFormLabel-root.MuiInputLabel-root.Mui-error": {
      color: "rgb(255,0,0,1)!important",
    },
    "& .MuiFormLabel-root.MuiInputLabel-root": {
      fontFamily: "Raleway",
      fontSize: "14px",
      fontWeight: "500",
      marginTop: "-2px",
    },
    "& .MuiInputBase-root.MuiFilledInput-root.Mui-error": {
      "&:before": {
        borderBottom: "1px solid #b1b1b1!important",
      },
    },
    "& .MuiInputBase-root.MuiFilledInput-root.Mui-focused": {
      "&:after": {
        borderBottom: "2px solid rgb(4 128 143)!important",
      },
    },
    "& label": {
      fontFamily: "Raleway",
      fontSize: "14px",
      fontWeight: "500",
      marginTop: "-5px",
    },
    "& .MuiFormHelperText-root.Mui-error": {
      color: "rgb(255, 0, 0, 1)!important",
    },
  },
  textoDescriptivo: {
    fontSize: "11px",
    lineHeight: "1.2",
    width: "100%",
    textAlign: "left",
    marginTop: "0.5rem",
    display: "block",
  },
  appLogo: {
    height: "45px",
    marginLeft: "-6px",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  customInput: {
    marginTop: "1rem",
    width: "90%",
    maxWidth: "380px",
  },
  containerLoginMobile: {
    [theme.breakpoints.down("md")]: {
      padding: "10px 15px!important",
    },
  },
  btn: button,
  outlinedBtn: outlinedBtn,
  containedBtn: containedBtn,
  btnCustomSize: {
    // fontSize: '16px!important',
    height: "43px",
    width: "100%",
  },
  textBtn: {
    ...textBtn,
    [theme.breakpoints.down("md")]: {
      height: "43px",
    },
  },
  homeLogo: {
    maxWidth: "100%",
    margin: "auto",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  appLogoMobile: {
    // height: "25px",
    margin: "10px",
    width: "60%",
    maxHeight: "100%",
    objectFit: "contain",
  },
  customContainerPreHome: {
    // padding: "20px",
    textAlign: "center",
    // height: "calc(100vh - 40px)",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "start",
    alignItems: "center",
    paddingBottom: "1rem",
  },
  customContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "start",
    alignItems: "center",
    // height: "calc(100vh - 40px)",
  },
  contentImageMobileHome: {
    maxHeight: "35vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100vw",
    maxWidth: "600px",
    // height: "calc(100vh - 215px)",
    background: homeImageBackgroundColor,
  },
  contentImageMobile: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100vw",
    maxWidth: "600px",
    // // height: "calc(100vh - 215px)",
    // background: homeImageBackgroundColor,
  },
  contentImageDesktop: {
    maxHeight: "45vh",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // height: "calc(100vh - 215px)",
    // background: homeImageBackgroundColor,
  },
  contentImageChildMobile: {
    display: "table-cell",
    verticalAlign: "middle",
  },
  divFijoFondo: {
    width: "-webkit-fill-available",
    position: "absolute",
    bottom: "20px",
    paddingRight: "20px",
    "& button": {
      display: "block",
      marginBottom: "15px",
      width: "100%",
    },
  },
  homeLogoMobile: {
    maxWidth: "380px",
    width: "100%",
    marginBottom: "10px",
  },
  bannerLogo: {
    width: "100%",
    margin: "auto",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  helperTxt,
  secondaryTxt,
  txtTitle,
  downloadBox: {
    display: "grid",
    gridTemplateColumns: "repeat(3, auto)",
    gap: "5px",
    alignItems: "center",
    alignContent: "center",
    height: "50px",
    color: "white",
    backgroundColor: "#608d8e",
    borderRadius: "13px",
    fontSize: "14px",
    padding: "4px 0px 0px 12px",
    fontWeight: "500",
    fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
    "& img": {
      height: "25px",
      cursor: "pointer",
    },
    [theme.breakpoints.down("md")]: {
      display: "block",
      padding: "5px 15px",
      fontSize: "12px",
      margin: "0px 15px 10px 15px",
      textAlignLast: "center",
      "& b": {
        width: "100%",
        display: "block",
      },
      "& img": {
        height: "25px",
        cursor: "pointer",
        marginTop: "3px",
        marginRight: "10px",
      },
    },
  },
  containerDownloadBox: {
    [theme.breakpoints.down("md")]: {
      paddingTop: "10px!important",
    },
  },
  captcha: {
    [theme.breakpoints.down("md")]: {
      fontSize: "12px",
    },
  },
  sentiteSeguroMobile: {
    [theme.breakpoints.down("md")]: {
      padding: "0px 15px",
      fontSize: "11px",
    },
  },
  descargaLaAppMobile: {
    [theme.breakpoints.down("md")]: {
      padding: "0px 15px",
      fontSize: "12px",
    },
  },
  formInputMobile: {
    [theme.breakpoints.down("md")]: {
      padding: "0px 0px!important",
    },
  },
  colorPink: {
    color: "#d00771",
  },
  modalContent: {
    position: "relative",
    backgroundColor: "#fff",
    borderRadius: "10px",
    maxHeight: "80vh",
    maxWidth: "85%",
    width: "320px",
    margin: "auto",
    border: "1px solid #60606047",
    boxShadow: "0px 0px 6px -2px rgba(0,0,0,1)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  modalContentDynamic: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: "0px!important",
    padding: "0rem 0.8rem 0.3rem",
  },
  modalContainerX: {
    width: "100%",
    textAlign: "right",
    marginTop: "-5px",
  },
  modalBody: {
    overflowY: "auto",
  },
  modalTitle: {
    fontWeight: "600",
    width: "100%",
    textAlign: "center",
    marginBottom: "0px",
    fontSize: "15px",
  },
  modalMessage: {
    maxWidth: "100%",
    textAlign: "center",
    marginTop: "1rem",
    fontSize: "15px!important",
    fontWeight: "500",
  },
  modalButton: {
    display: "block",
    margin: "20px auto 0",
  },
  closeButtonContainer: {
    position: "absolute",
    display: "flex",
    alignItems: "end",
    top: "10px",
    right: "10px",
    padding: 0,
    backgroundColor: "transparent",
  },
  closeButton: {
    color: "#606060",
    fontSize: "24px",
    // alignSelf: "end",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  labelAUnPaso: {
    lineHeight: "1.2",
    width: "90%",
    maxWidth: "380px",
    fontWeight: "700",
    textAlign: "center",
    color: "#04808F",
    marginTop: "1.5rem",
  },
  iconLaborales: {
    marginRight: "8px",
    width: "24px",
    height: "24px",
    marginLeft: "0rem",
    [theme.breakpoints.down("sm")]: {
      marginLeft: "1rem",
    },
  },
  divSubtitulo: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "start",
    marginTop: "2rem",
    width: "100%",
    marginBottom: "0.5rem",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "-15px",
    },
  },
  modalBoxFooter: {
    width: "100%",
    borderTop: "1px solid #bfbfbf",
    textAlign: "center",
    marginTop: "1.5rem",
  },
  modalImageContainer: {
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    backgroundColor: "#fff",
    position: "absolute",
    top: "-35px",
    left: "50%",
    transform: "translateX(-50%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "0.5px solid #bfbfbf",
    "& img": {
      maxWidth: "100%",
      maxHeight: "100%",
    },
  },
  modalImage: {
    width: "80%",
    height: "80%",
    borderRadius: "50%",
  },
  modalFooterImage: {
    width: "40%",
    maxWidth: "150px",
    margin: "0.7rem",
  },
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgb(255 255 255 / 85%)",
    zIndex: 1300,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    zIndex: 1300,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  iconDocuments: {
    maxWidth: "23px",
    margin: "5px 10px 5px 0px",
  },
  spinner: {
    border: "4px solid rgba(0, 0, 0, 0.1)",
    borderLeftColor: "#000",
    borderRadius: "50%",
    width: "40px",
    height: "40px",
    animation: "$spin 1s linear infinite",
  },
  parrafo: {
    fontSize: "17px",
    lineHeight: "1",
    fontWeight: "400",
    textAlign: "center",
    marginBottom: "2rem",
  },
  parrafoMobile: {
    fontSize: "13.5px",
    textAlign: "left",
    marginTop: "0.2rem",
    width: "90%",
  },
  parrafoMobileOferta: {
    fontSize: "14.5px",
    textAlign: "left",
    marginTop: "1rem",
    width: "90%",
    fontWeight: "500",
  },
  colorAzul: {
    color: "#04808F",
  },
  divBeneficios: {
    width: "90%",
    // marginTop: "5px",
    display: "flex",
    minHeight: "40px",
    fontSize: "13px",
    alignItems: "center",
  },
  divBtn: {
    width: "90%",
    marginTop: "10px",
  },
  btnFull: {
    width: "100%",
    fontFamily: "Raleway !important",
    height: "40px",
    fontSize: "15px!important",
    // color: "white!important",
    borderRadius: "8px!important",
    fontWeight: "600",
  },
  btnTarjPlata: {
    background:
      "linear-gradient(180deg, rgba(105,105,105,1) 0%, rgba(13,13,13,1) 100%)",
    color: "white!important",
  },
  btnTarjPlata2: {
    background:
      "linear-gradient(180deg, rgba(105,105,105,1) 0%, rgba(13,13,13,1) 100%)",
    color: "white!important",
    textTransform: "none!important",
    fontSize: "11px!important",
    maxWidth: "320px",
  },
  divBtnTarjetaPlata2: {
    height: "15px",
    display: "flex",
    alignItems: "center",
  },
  divRightBtnTarjetaPlata2: {
    width: "50%",
    fontSize: "15px",
    alignSelf: "center",
    alignContent: "space-around",
    justifyContent: "center",
  },
  btnTarjOro: {
    backgroundColor: "#FFCA42!important",
    color: "black!important",
  },
  btnTarjPlatino: {
    backgroundColor: "#00DBDC!important",
    color: "black!important",
  },
  btnTarjPlatinoMas: {
    backgroundColor: "#D00771!important",
    color: "white!important",
  },
  btnAzul: {
    backgroundColor: "#04808f!important",
    color: "white!important",
  },
  optionAutocomplete: {
    padding: "10px",
  },
  "@keyframes spin": {
    "0%": {
      transform: "rotate(0deg)",
    },
    "100%": {
      transform: "rotate(360deg)",
    },
  },
}));

export default appStyle;
